export class SettingsEvents {
  public static settingsPopulateMenu = 'settingsPopulateMenu';
}



/** WEBPACK FOOTER **
 ** ./src/events/SettingsEvents.ts
 **/